const baseZIndex = 1;
const overlayZIndex = 1000;
const overlayOffset = 100;
export function getDesignZIndex() {
    return {
        base: baseZIndex, // >=1 common base layer zIndex
        overlay: overlayZIndex, // >=1000 common ovelay zIndex
        // base layer
        // XXX: baseZIndex + overlayOffset * 1, // >=101
        // TODO new components
        // overlay
        Drawer: overlayZIndex + overlayOffset * 2, // >=1200
        Dialog: overlayZIndex + overlayOffset * 3, // >=1300
        DatePicker: overlayZIndex + overlayOffset * 3, // >=1300
        TimePicker: overlayZIndex + overlayOffset * 3, // >=1300
        ColorPicker: overlayZIndex + overlayOffset * 3, // >=1300
        Dropdown: overlayZIndex + overlayOffset * 3, // >=1300
        Popover: overlayZIndex + overlayOffset * 3, // >=1300
        Toast: overlayZIndex + overlayOffset * 4, // >=1400
        Tooltip: overlayZIndex + overlayOffset * 5, // >=1500
        // TODO new components
    };
}
